export const SPOT_BOOKING_FROM = {
  ACTIVITY_DETAIL: 'activity_detail',
}
